// removed by extract-text-webpack-plugin
module.exports = {"authLoginUserIcon":"AuthStatus-hashed__authLoginUserIcon__2fhJD","authLoginUserName":"AuthStatus-hashed__authLoginUserName__fmjdC"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/AuthStatus/AuthStatus-hashed.scss
// module id = 1151
// module chunks = 0